import httpRequest from "../apis/httpRequest";
import { SETUP_URL, NO_SETTING, HAS_SETTING } from './types';
//检测setting
const checkSetting = () => {
  return dispatch => {
    const request = httpRequest.get(SETUP_URL);
    request.then(function (res) {
      if (res.data.shouldSetup) {
        dispatch({
          type: NO_SETTING,
          payload: "需要进行初始化"
        });
      } else {
        dispatch({
          type: HAS_SETTING,
          payload: res
        });
      }
    })
  };
}
export { checkSetting }